import { v4 as uuidv4 } from 'uuid';

/**
 * Service for managing user session in localStorage
 * Maintains a persistent session ID across browser visits
 */
export class SessionService {
  private static readonly SESSION_ID_KEY = 'callOS_sessionId';
  
  /**
   * Get the current session ID, creating one if it doesn't exist
   */
  static getSessionId(): string {
    let sessionId = localStorage.getItem(this.SESSION_ID_KEY);
    
    if (!sessionId) {
      sessionId = uuidv4();
      localStorage.setItem(this.SESSION_ID_KEY, sessionId);
    }
    
    return sessionId;
  }
  
  /**
   * Clear the current session (for testing/reset)
   */
  static clearSession(): void {
    localStorage.removeItem(this.SESSION_ID_KEY);
  }
  
  /**
   * Get session info for debugging
   */
  static getSessionInfo(): { sessionId: string; created: boolean } {
    const existing = localStorage.getItem(this.SESSION_ID_KEY);
    const sessionId = this.getSessionId();
    
    return {
      sessionId,
      created: !existing
    };
  }
}